import { createContext } from "react";

const GuestbookContext = createContext({
  totalComments: 0,
  guestbookKey: "",
  increaseTotalComments: () => {},
});

export default GuestbookContext;
